import { render, staticRenderFns } from "./FooterPaymentMethods.vue?vue&type=template&id=313ed675&scoped=true&"
import script from "./FooterPaymentMethods.vue?vue&type=script&lang=js&"
export * from "./FooterPaymentMethods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313ed675",
  null
  
)

export default component.exports